import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ThemeCustomizerService } from '../theme-customizer/theme-customizer.service';
import { HttpClientModule } from '@angular/common/http';
import { TranslationService } from 'src/app/shared/i18n/translation.service';
import { CategoryNewsService } from 'src/app/services/category-news.service';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { LookUpService } from 'src/app/services/lookup.service';

@Component({
    selector: 'app-header-style-two',
    templateUrl: './header-style-two.component.html'
})
export class HeaderStyleTwoComponent implements OnInit {
    youtube: string | undefined;
    twitter: string | undefined;
    linkedin: string | undefined;
    instagram: string | undefined;
    faceBook: string | undefined;
    email: string | undefined;
    adress: string | undefined;
    phone: string | undefined;
    logoHeader: string | undefined;

    categoryNews: any[] = [];
    isSticky: boolean = false;
    checkScroll() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (scrollPosition >= 50) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }

    isToggled = false;

    constructor(
        public themeService: ThemeCustomizerService,
        private translationService: TranslationService,
        public service: CategoryNewsService,
        private lookUpService: LookUpService,
        public router: Router
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void {
        this.service.getAll$().subscribe(x => {
            this.categoryNews = x

        })
        this.lookUpService.getAll$().subscribe(x => {
            this.twitter = x.find(x => x?.name == "Twitter")?.value;
            this.instagram = x.find(x => x?.name == "Instagram")?.value;
            this.faceBook = x.find(x => x?.name == "FaceBook")?.value;
            this.linkedin = x.find(x => x?.name == "Linkedin")?.value;
            this.youtube = x.find(x => x?.name == "Youtube")?.value;
            this.email = x.find(x => x?.name == "Email")?.value;
            this.phone = x.find(x => x?.name == "Phone")?.value;
            this.logoHeader = x.find(x => x?.name == "LogoHeader")?.value;
        });
    }

    classApplied = false;
    toggleClass() {
        this.classApplied = !this.classApplied;
    }

    classApplied2 = false;
    toggleClass2() {
        this.classApplied2 = !this.classApplied2;
    }

    classApplied3 = false;
    toggleClass3() {
        this.classApplied3 = !this.classApplied3;
    }
    isDropdownOpen = false;
    isCatOpen = false;
    isMobileCatOpen = false;

    toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    currentLanguage = { name: 'English', flag: 'path/to/english-flag.png' }; // Set default language

    language: LanguageFlag = new LanguageFlag();
    setLanguageWithRefresh(lang: any) {
        this.setLanguage(lang);
        document.documentElement.setAttribute('lang', 'de');
        window.location.reload();
    }
    setLanguage(lang: any) {
        this.languages.forEach((language: LanguageFlag) => {
            if (language.lang === lang) {
                language.active = true;
                this.language = language;
            } else {
                language.active = false;
            }
        });
        this.translationService.setLanguage(lang);
    }
    languages: LanguageFlag[] = [
        {
            lang: 'en',
            name: 'English',
            flag: './assets/img/us-flag.jpg',
        },
        {
            lang: 'ar',
            name: 'Arabic',
            flag: './assets/media/flags/008-saudi-arabia.svg',
        },
        {
            lang: 'tr',
            name: 'Tr',
            flag: './assets/media/flags/006-turkey.svg',
        },
    ];
    setSelectedLanguage(): any {
        this.setLanguage(this.translationService.getSelectedLanguage());
    }

    openSocalMediaNewWindow(id: string | undefined) {
        this.lookUpService.openSocalMediaNewWindow(id);
    }
    createImgPath = (serverPath: string) => {
        return this.lookUpService.createImgPath(serverPath);
    }
}
export class LanguageFlag {
    lang: string = "";
    name: string = "";
    flag: string = "";
    active?: boolean = false;
}